import { Divider, Modal, Text } from "@mantine/core";
import { AnswerWithSources } from "./AnswerWithSources";
import type { FeedbackSchema } from "./MetadataFeedback/types";
import { AnswerReviewSection } from "./shared/AnswerReviewSection";
import { extractReferencesFromFeedback } from "./shared/referenceUtils";

interface FeedbackModalProps {
    rowData: FeedbackSchema | null;
    onClose: () => void;
}

const FeedbackModal = ({ rowData, onClose }: FeedbackModalProps) => {
    const answer = rowData?._source?.cts_answer?.answer || "";
    const references = extractReferencesFromFeedback(rowData);

    const userFeedbackType = rowData?._source?.cts_answer?.feedback_type;
    const userFeedbackComments = rowData?._source?.cts_answer?.comments;
    const smeFeedbackType = rowData?._source?.evaluations?.sme?.feedback_type;
    const smeFeedbackComments = rowData?._source?.evaluations?.sme?.comments;

    const beforeMetadata = (
        <>
            {userFeedbackType ? (
                <>
                    <Divider my="md" />
                    <h3>User Feedback</h3>
                    <h4 style={{ display: "inline" }}>
                        Feedback Type: &nbsp;
                        <Text
                            style={{
                                color:
                                    userFeedbackType.toLowerCase() === "positive" ? "green" : "red",
                                display: "inline",
                            }}
                        >
                            {userFeedbackType}
                        </Text>
                    </h4>
                </>
            ) : null}
            {userFeedbackComments ? (
                <>
                    <br />
                    <h4 style={{ display: "inline" }}>Feedback Comments: &nbsp;</h4>
                    {userFeedbackComments}
                </>
            ) : null}
            {smeFeedbackType ? (
                <>
                    <Divider my="md" />
                    <h3>SME Feedback</h3>
                    <h4 style={{ display: "inline" }}>
                        Feedback Type: &nbsp;
                        <Text
                            style={{
                                color:
                                    smeFeedbackType.toLowerCase() === "positive" ? "green" : "red",
                                display: "inline",
                            }}
                        >
                            {smeFeedbackType}
                        </Text>
                    </h4>
                </>
            ) : null}
            {smeFeedbackComments ? (
                <>
                    <br />
                    <h4 style={{ display: "inline" }}>Feedback Comments: &nbsp;</h4>
                    {smeFeedbackComments}
                </>
            ) : null}
        </>
    );

    return (
        <Modal opened={rowData !== null} onClose={onClose} title="Feedback" size="xl" py="sm">
            <AnswerReviewSection
                orgCode={rowData?._source?.org_code}
                origin={rowData?._source?.origin}
                question={rowData?._source?.question}
                answer={answer}
                references={references}
                metadata={[
                    { label: "Conversation Id", value: rowData?._source?.conversation_id },
                    { label: "Response Id", value: rowData?._source?.id },
                    { label: "User Id", value: rowData?._source?.user },
                ]}
                requestOptions={rowData?._source?.request_options}
                beforeMetadata={beforeMetadata}
                renderAnswer={({ answer: renderedAnswer, references: answerReferences }) => (
                    <AnswerWithSources answer={renderedAnswer} references={answerReferences} />
                )}
            />
        </Modal>
    );
};

export default FeedbackModal;
